import React from 'react'

import Icon from '@/components/common/Icon'

const IconCard: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, height, width }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 41 41"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="#fff"
      stroke="#E6E7E8"
      d="M39.804 6.96c.291 0 .555.118.747.31.193.193.31.456.31.744v24.848a1.055 1.055 0 01-1.058 1.053H2.541c-.29 0-.554-.118-.747-.31a1.047 1.047 0 01-.31-.743V8.014A1.055 1.055 0 012.54 6.96h37.263z"
    />
    <path
      fill="url(#paintDiners0_linear)"
      fillRule="evenodd"
      d="M22.758 27.863c4.03.02 7.708-3.317 7.708-7.375 0-4.439-3.678-7.506-7.709-7.505H19.29c-4.078-.001-7.435 3.067-7.435 7.505 0 4.06 3.357 7.394 7.435 7.375h3.468z"
      clipRule="evenodd"
    />
    <path
      fill="url(#paintDiners1_linear)"
      fillRule="evenodd"
      d="M22.758 27.863c4.03.02 7.708-3.317 7.708-7.375 0-4.439-3.678-7.506-7.709-7.505H19.29c-4.078-.001-7.435 3.067-7.435 7.505 0 4.06 3.357 7.394 7.435 7.375h3.468z"
      clipRule="evenodd"
    />
    <path
      fill="#F4F6F7"
      fillRule="evenodd"
      d="M19.303 13.603c-3.726.002-6.746 3.05-6.747 6.812 0 3.761 3.02 6.81 6.747 6.81 3.728 0 6.748-3.049 6.749-6.81 0-3.762-3.021-6.81-6.749-6.812zm-4.277 6.812a4.323 4.323 0 012.746-4.03v8.058a4.321 4.321 0 01-2.746-4.028zm5.808 4.03v-8.06a4.32 4.32 0 012.748 4.03 4.322 4.322 0 01-2.748 4.03z"
      clipRule="evenodd"
    />
    <path
      fill="#F4F6F7"
      fillRule="evenodd"
      d="M19.303 13.603c-3.726.002-6.746 3.05-6.747 6.812 0 3.761 3.02 6.81 6.747 6.81 3.728 0 6.748-3.049 6.749-6.81 0-3.762-3.021-6.81-6.749-6.812zm-4.277 6.812a4.323 4.323 0 012.746-4.03v8.058a4.321 4.321 0 01-2.746-4.028zm5.808 4.03v-8.06a4.32 4.32 0 012.748 4.03 4.322 4.322 0 01-2.748 4.03z"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="paintDiners0_linear"
        x1="25.022"
        x2="19.99"
        y1="25.178"
        y2="14.667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009BE0" />
        <stop offset="1" stopColor="#006BA8" />
      </linearGradient>
      <linearGradient
        id="paintDiners1_linear"
        x1="25.022"
        x2="19.99"
        y1="25.178"
        y2="14.667"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#009BE0" />
        <stop offset="1" stopColor="#006BA8" />
      </linearGradient>
    </defs>
  </svg>
)

export default Icon(IconCard)
